import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DynamicHttpTableComponent } from '@components/ng-dynamic-http-table';
import { Roles } from '../../../../utils/enums';
import { UserService } from '../../../../services/user.service';
import { userRoles } from '../../../../utils/display-texts';

@Component({
  selector: 'app-change-roles',
  templateUrl: './change-roles.component.html',
  styleUrls: ['./change-roles.component.scss']
})
export class ChangeRolesComponent {
  userForm: FormGroup;
  roles = [Roles.ADMIN, Roles.SUPPORT];
  displayRoles = userRoles;

  constructor(
    private builder: FormBuilder,
    private dialogRef: MatDialogRef<ChangeRolesComponent>,
    @Inject(MAT_DIALOG_DATA) public data:
      { userEmail: string, currentRoles: string[], userTable: DynamicHttpTableComponent },
    private userService: UserService
  ) {
    this.userForm = this.builder.group({
      email: [{ value: data.userEmail, disabled: true }, [Validators.required, Validators.email]],
      roles: [data.currentRoles?.length ? data.currentRoles : []]
    });
  }

  /**
   * Change the roles and update the table
   */
  changeRoles(): void {
    if (this.userForm.valid) {
      this.userService.changeRoles(this.userForm.getRawValue()).subscribe(() => {
        this.data.userTable?.getResults();
        this.dialogRef.close();
      });
    }
  }
}
